import { type NodeViewProps } from "@tiptap/react";

import type { Document as DocumentType } from "@app-types/common.type";
import type { UploaderItem } from "../../extensions";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    document: {
      /**
       * Insert a document node.
       *
       * @param options - The document attributes.
       * @returns The command.
       */
      insertDocument: (options: DocumentAttributes) => ReturnType;
      /**
       * Update a document node.
       *
       * @param id - The document ID.
       * @param options - The document attributes.
       * @returns The command
       **/
      updateDocumentById: (id: string, options: Partial<DocumentAttributes>) => ReturnType;
      /**
       * load a document from the user's device.
       *
       * @returns The command.
       */
      loadDocument: () => ReturnType;
      /**
       * Upload a document list
       */
      uploadDocuments: (files: File[]) => ReturnType;
      /**
       * Cancel the upload of a document.
       */
      cancelDocumentUpload: (id: string) => ReturnType;
      /**
       * Download a document.
       *
       * @param id - The document ID.
       * @returns The command.
       */
      downloadDocumentById: (id: string) => ReturnType;
      /**
       * Remove a document node.
       *
       * @param id - The document ID.
       * @returns The command.
       */
      removeDocumentById: (id: string) => ReturnType;
    };
  }
}

export type DocumentOptions = {
  HTMLAttributes: Record<string, any>;
  component: React.ComponentType<NodeViewProps>;
  onUpload: (files: File[], signal: AbortSignal) => Promise<Array<DocumentType>>;
  onDelete: (file: DocumentAttributes) => Promise<void>;
};

export type DocumentStorage = {
  uploader: UploaderItem;
  uploads: Map<string, AbortController>;
};

export type DocumentAttributes = {
  id: string | null;
  file: string | null;
  file_name: string | null;
  created: string | null;
  user_id: string | null;
  preview_url: string | null;
  user_full_name: string | null;
  user_avatar_url: string | null;
  uploading: boolean;
  show_preview: boolean;
};
